//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import {
  mdiFolderOutline,
  mdiAccountMultipleOutline,
  mdiStarOutline,
  mdiHistory,
  mdiCheckCircleOutline,
  mdiUploadOutline,
  mdiCloudUploadOutline,
} from '@mdi/js'

export default {
  setup() {
    const selectedItem = ref(0)
    const items = [
      { text: 'My Files', icon: mdiFolderOutline },
      { text: 'Shared with me', icon: mdiAccountMultipleOutline },
      { text: 'Starred', icon: mdiStarOutline },
      { text: 'Recent', icon: mdiHistory },
      { text: 'Offline', icon: mdiCheckCircleOutline },
      { text: 'Uploads', icon: mdiUploadOutline },
      { text: 'Backups', icon: mdiCloudUploadOutline },
    ]

    return { selectedItem, items }
  },
}
